<template>
  <SOSlotBase
      :is-search="isSearch"
      :bg-grey="!pageSetting.loading.export"
      :bg-white="pageSetting.loading.export"
      :container-name="'list-topup-epayment'"
  >
    <template v-slot:title-bar>
      <SOTitleBar
          :page-title="'Top Up Epayment'"
          :type="'back'"
          :show-search="!pageSetting.loading.list"
          @search="search"
          @back="back"
          v-if="!isSearch && !pageSetting.loading.export"
      />
    </template>

    <template v-slot:search-bar>
      <SOSearchBar
          v-if="isSearch && !pageSetting.loading.export"
          :context="'Top Up Epayment'"
          :value="searchKey.key"
          :data-count="pageSetting.loading.list ? 0 : listTopupData.lenght_data"
          :waiting="pageSetting.search.waiting"
          :search-information="'Nomor nota, nama konsumen, & nama outlet'"
          @return-search-value="(v) => { searchKey.key = v }"
          @loading="loadingSearch"
          @do-search="searchTopup"
          @close="closeSearch"
      />
    </template>

    <template v-slot:skeleton>
      <div class="p-x-20 p-y-16 w-limit" v-if="pageSetting.loading.list">
        <SOCardTransaksiSkeleton v-if="!isSearch"/>
        <SOLoadSearch v-if="isSearch"/>
      </div>
    </template>

    <template v-slot:empty-state>
      <SOEmptyState
          v-if="listTopupData.lenght_data === 0 && !isSearch"
          :message="'Belum Ada Transaksi'"
          :sub-message="'Daftar Top Up Epayment akan muncul disini'"
      />
      <SOEmptySearchState
          v-if="isSearch && !pageSetting.loading.list && !pageSetting.search.waiting && listTopupData.lenght_data === 0 && searchKey.key.length > 2"
          @action="() => { resetFilter(); searchKey.key = '' }"
      />
    </template>

    <template v-slot:content v-if="!pageSetting.loading.export">
      <SOExportProgressMinimized
          v-if="pageSetting.minimizedExport"
          :processed-data="exportProgress.processed"
          :total-data="exportProgress.total"
          :context="'topup epayment'"
          :tracker-actions="'epaymentModule/exportTrack'"
          @on-success="checkExport"
          @on-error="() => { pageSetting.minimizedExport = false }"
      />
      <SOExportMultipleFile
          v-if="pageSetting.multipleExport && !pageSetting.minimizedExport"
          :export-data="exportData"
          :export-data-length="exportDataLength"
          :delete-cluster-actions="'epaymentModule/exportDeleteCluster'"
          :delete-master-actions="'epaymentModule/exportDeleteMaster'"
          @downloaded="(index) => { exportData[index].downloaded = true }"
          @done="() => { pageSetting.multipleExport = false; exportData = [] }"
      />

      <div class="p-x-20 p-t-16 w-limit" v-if="!pageSetting.loading.list">
        <SOHeaderList
            :title="titleHeaderListEpayment()"
            :action-text="listTopupData.data.length > 0 ? '  •  <span class=\'f-semi f-14 f-c-blue\'>Lihat Ringkasan</span>' : ''"
            :show-filter="true"
            @action="() => { pageSetting.modal.summary = true }"
            @filter="() => { pageSetting.showFilter = true }"
        />

        <SOCardTopupEpayment
            v-for="transaksi in listTopupData.data"
            :key="transaksi.idtransaksi"
            :transaksi="transaksi"
            :is-search="isSearch"
            :key-search="searchKey.key"
        />

        <SOLoadMoreLoading :id="'loading-list-topup-epayment'" :loading="pageSetting.loading.loadMore"/>
      </div>

      <SOFABExport
          v-if="!pageSetting.loading.list && listTopupData.data.length > 0"
          @export="() => { pageSetting.modal.export = true }"
      />
    </template>

    <template v-slot:filter>
      <div class="p-x-20 p-t-16 w-limit">
        <SOFilter
            v-if="pageSetting.showFilter"
            :filter-paket-epayment="pageSetting.showFilter"
            :sorting="sorting"
            @back="() => { pageSetting.showFilter = false }"
            @do-filter="doFilter"
            @reset-filter="resetFilter"
        />
      </div>
    </template>

    <template v-slot:modal>
      <TopupEpaymentModalRingkasan
          v-if="pageSetting.modal.summary"
          :is-loading="pageSetting.loading.ringkasan"
          @close="() => { pageSetting.modal.summary = false }"
      />

      <SOModalExport
          v-if="pageSetting.modal.export"
          :is-running="pageSetting.minimizedExport"
          :context="'Top Up E-payment'"
          :total-data="listTopupData.lenght_data  + ' Nota'"
          :export-data-exist="exportData.length > 0 ? exportData.filter(v => v.downloaded === false).length : 0"
          @close="() => { pageSetting.modal.export = false }"
          @do-export="doExport"
      />
    </template>

    <template v-slot:export-import>
      <SOExportProgress
          v-if="pageSetting.loading.export"
          :context="'topup epayment'"
          :tracker-actions="'epaymentModule/exportTrack'"
          @on-success="checkExport"
          @on-error="() => { pageSetting.loading.export = false }"
          @minimized-export="minimizedExport"
      />
    </template>
  </SOSlotBase>
</template>

<script>
import {mapGetters} from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";

import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOCardTransaksiSkeleton from "@/so-components/modules/transaksi/reguler/SOCardTransaksiSkeleton";
import SOLoadSearch from "@/so-components/global/ui/SOLoadSearch";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOCardTopupEpayment from "@/so-components/modules/topup-epayment/SOCardTopupEpayment";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOFABExport from "@/so-components/global/ui/SOFABExport";
import SOFilter from "@/so-components/global/filter/base/SOFilter";

import TopupEpaymentModalRingkasan from "./modal/TopupEpaymentModalRingkasan";
import SOModalExport from "@/so-components/global/modal/SOModalExport";

import SOExportProgressMinimized from "@/so-components/global/ui/SOExportProgressMinimized";
import SOExportMultipleFile from "@/so-components/global/ui/SOExportMultipleFile";
import SOExportProgress from "@/so-components/global/ui/SOExportProgress";

export default {
  name: "TopupEpayment",
  components: {
    SOSlotBase,

    SOTitleBar,
    SOSearchBar,
    SOCardTransaksiSkeleton,
    SOLoadSearch,
    SOEmptyState,
    SOEmptySearchState,
    SOHeaderList,
    SOCardTopupEpayment,
    SOLoadMoreLoading,
    SOFABExport,
    SOFilter,

    TopupEpaymentModalRingkasan,
    SOModalExport,

    SOExportProgressMinimized,
    SOExportMultipleFile,
    SOExportProgress,
  },
  computed: {
    ...mapGetters("epaymentModule", {
      listTopupData: "getListTopupEpayment",
      info: "getInfoTopupEpayment",
      pagination: "getPagination",
      searchKey: "getSearchTopup",
      isSearch: "getIsSearchTopup",
      scrollPosition: "getScrollPosition",
    }),
    ...mapGetters("filterGlobalModule", {
      filter: "getFilter",
      filterItem: "getFilterItem",
    }),
  },
  data() {
    return {
      sorting: [
        {
          label: "Transaksi terbaru",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "transaksi",
            orderBy: "DESC",
          }),
          id: "sorting-1"
        },
        {
          label: "Transaksi terlama",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "transaksi",
            orderBy: "ASC",
          }),
          id: "sorting-2"
        },
        {
          label: "Nominal tertinggi",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "nominal",
            orderBy: "DESC",
          }),
          id: "sorting-3"
        },
        {
          label: "Nominal terendah",
          name: "sorting",
          value: JSON.stringify({
            sortBy: "nominal",
            orderBy: "ASC",
          }),
          id: "sorting-4"
        },
      ],
      pageSetting: {
        showFilter: false,

        loading: {
          list: true,
          loadMore: false,
          export: false,
          ringkasan: false,
        },
        minimizedExport: false,
        multipleExport: false,
        modal: {
          summary: false,
          export: false,
        },
        search: {
          waiting: false,
        },
        error: {
          list: false,
        },
      },
      exportProgress: {
        processed: 0,
        total: 0,
      },
      exportData: [],
      exportDataLength: 0
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let query = vm.$route.query
      if (from.path.split("/")[1] !== "transaksi" && from.path.split("/")[2] !== "epayment") {
        if (from.path.split("/")[1] === "pembatalan_topup_epayment") {
          vm.setScrollPosition()
          return
        }
        vm.initTopupEpayment(query)
      } else if (from.path.split("/")[1] === "transaksi" && from.path.split("/")[2] !== "epayment") {
        vm.initTopupEpayment(query)
      } else {
        if (vm.listTopupData.data === undefined) {
          vm.initTopupEpayment(query)
          return
        }
        vm.setScrollPosition()
      }
    })
  },
  async mounted() {
    // await this.setDefaultFilter()
    // await this.getInfoTopup()
    // await this.listTopup()
    await this.scroll()
    await this.checkExport()
    this.smartTrackingView("top_up_e-payment");

  },
  methods: {
    back() {
      this.$router.push({name: "TransaksiDanPenghapusan"});
    },
    async initTopupEpayment(query) {
      await this.flushData()
      await this.setDefaultFilter(query)
      this.getInfoTopup()
      await this.listTopup()
    },
    async listTopup() {
      if (!this.pageSetting.loading.list) {
        this.pageSetting.loading.loadMore = true
      }
      if (this.listTopupData.data !== undefined && this.listTopupData.data.lenght === 0) {
        this.pageSetting.search.waiting = true
      }
      const res = await this.$store.dispatch("epaymentModule/fetchListTopupEpayment")
      this.pageSetting.loading.list = false
      this.pageSetting.loading.loadMore = false
      this.pageSetting.search.waiting = false
      this.$store.commit("helper/setScrollCalled", false)
      if (res.success) {
        this.pageSetting.error.list = false
        await this.$store.commit("epaymentModule/setNextPagination", {data: this.listTopupData.data})
      } else {
        this.pageSetting.error.list = true
        setTimeout(() => {
          this.pageSetting.error.list = false
        }, 10000)
        this.$toast.error(res.err)
      }
    },
    async getInfoTopup() {
      this.pageSetting.loading.ringkasan = true
      const res = await this.$store.dispatch("epaymentModule/fetchInfoTopUpEpayment")
      this.pageSetting.loading.ringkasan = false
      if (!res.success) {
        this.$toast.error(res.err)
      }
    },
    titleHeaderListEpayment() {
      let strTotal = this.isSearch ? '' : 'Total '
      if (this.isSearch && this.searchKey.key.length < 2) {
        return ''
      } else if (this.isSearch && this.searchKey.key.length >= 2) {
        if (this.listTopupData.data !== undefined && this.listTopupData.data.length > 0) {
          return strTotal + this.formatRupiah(this.listTopupData.lenght_data) + ' Nota'
        }
      } else {
        if (this.listTopupData.data !== undefined) {
          return strTotal + this.formatRupiah(this.listTopupData.lenght_data) + ' Nota'
        } else {
          return strTotal + '0 Nota'
        }
      }
    },

    scroll() {
      window.onscroll = async () => {
        if (this.pageSetting.error.list) {
          return
        }
        let payload = {
          idLoadMore: "loading-list-topup-epayment",
          container: "list-topup-epayment",
          pagination: this.pagination,
          callback: this.listTopup,
        }
        await this.$store.dispatch("helper/scroll", payload)
      }
    },
    setScrollPosition() {
      this.pageSetting.loading.list = false
      setTimeout(() => {
        window.scrollTo(0, this.scrollPosition)
      }, 5)
    },

    // filter
    async setDefaultFilter(query) {
      // let query = this.$route.query
      await this.$store.commit("filterGlobalModule/resetFilterItem")
      if (Object.keys(query).length > 0) {
        let filterItem = this.filterItem

        if (query.filter_by) filterItem.periode.filterBy = query.filter_by
        if (query.tanggal_awal) filterItem.periode.startDate = query.tanggal_awal
        if (query.tanggal_akhir) filterItem.periode.endDate = query.tanggal_akhir
        if (query.bulan) filterItem.periode.month = query.bulan
        if (query.tahun) filterItem.periode.year = query.tahun
        if (query.outlet_array) filterItem.outlet = (Array.isArray(query.outlet_array)) ? query.outlet_array : [query.outlet_array]
        if (query.epayment_array) filterItem.epayment = (Array.isArray(query.epayment_array)) ? query.epayment_array : [query.epayment_array]
        if (query.karyawan) filterItem.karyawan = query.karyawan
        if (query.metode_topup) filterItem.metodeTopup = query.metode_topup

        await this.$store.commit("filterGlobalModule/setFilterItem", filterItem)

        if (query.key) {
          await this.$store.commit("epaymentModule/setSearchTopup", query.key)
          await this.$store.commit("epaymentModule/setIsSearchTopup", true)
        }

        let temp = this.filter
        temp.sortBy = query.sort_by
        temp.orderBy = query.order_by
        await this.$store.commit("filterGlobalModule/setFilter", temp)
      } else {
        await this.resetFilter()
      }

      await this.$store.commit("epaymentModule/resetPagination")
    },
    async resetFilter() {
      let temp = this.filter
      temp.sortBy = "transaksi"
      temp.orderBy = "DESC"
      await this.$store.commit("filterGlobalModule/resetFilterItem")
      await this.$store.commit("filterGlobalModule/setFilter", temp)
    },
    async doFilter() {
      this.pageSetting.showFilter = false
      if (this.isSearch && this.searchKey.key.length < 2) {
        return
      }
      this.pageSetting.loading.list = true
      this.pageSetting.search.waiting = true
      await this.$store.commit("epaymentModule/resetPagination")
      await this.$store.commit("epaymentModule/resetListTopupEpayment")
      this.getInfoTopup()
      await this.listTopup()
    },

    // search
    async search() {
      window.scrollTo(0, 0)
      // await this.resetFilter()
      await this.$store.commit("epaymentModule/setIsSearchTopup", true)

      this.listTopupData.data = []
      this.listTopupData.lenght_data = 0
      await this.$store.commit("epaymentModule/resetSearchTopup")
      // await this.$store.commit("epaymentModule/resetListTopupEpayment")
      await this.$store.commit("epaymentModule/resetInfoTopupEpayment")
      await this.$store.commit("epaymentModule/resetPagination")
    },
    async loadingSearch(loading) {
      if (!loading) {
        this.listTopupData.data = []
        this.listTopupData.lenght_data = 0
      }
      this.pageSetting.search.waiting = loading
      this.pageSetting.loading.list = loading
    },
    async searchTopup(search) {
      await this.$store.commit("epaymentModule/resetSearchTopup")
      await this.$store.commit("epaymentModule/resetListTopupEpayment")
      await this.$store.commit("epaymentModule/resetInfoTopupEpayment")
      await this.$store.commit("epaymentModule/resetPagination")

      await this.$store.commit("epaymentModule/setSearchTopup", search)
      this.getInfoTopup()
      await this.listTopup()
      this.pageSetting.search.waiting = false
    },
    async closeSearch() {
      this.pageSetting.loading.list = true
      // await this.resetFilter()
      await this.$store.commit("epaymentModule/setIsSearchTopup", false)

      await this.$store.commit("epaymentModule/resetSearchTopup")
      await this.$store.commit("epaymentModule/resetListTopupEpayment")
      await this.$store.commit("epaymentModule/resetInfoTopupEpayment")
      await this.$store.commit("epaymentModule/resetPagination")

      this.getInfoTopup()
      await this.listTopup()
      this.pageSetting.loading.list = false
    },

    // export
    async doExport() {
      this.pageSetting.loading.export = true
      this.pageSetting.modal.export = false
      const res = await this.$store.dispatch("epaymentModule/export", {
        type: "topup_epayment_export"
      })
      if (!res.success) {
        this.pageSetting.loading.export = false
        this.$toast.error(res.err)
      }
    },
    minimizedExport(data) {
      this.pageSetting.loading.export = false
      this.pageSetting.minimizedExport = true
      this.exportProgress.processed = Number(data.processed)
      this.exportProgress.total = Number(data.total)
    },
    async checkExport() {
      this.pageSetting.loading.export = false
      this.pageSetting.minimizedExport = false
      this.pageSetting.multipleExport = false
      const res = await this.$store.dispatch("epaymentModule/exportTrack")
      if (!res.success) {
        return
      }
      this.exportDataLength = res.data.length
      if (res.data.info_data_export.length > 0) {
        if (res.data.status === 1) {
          this.pageSetting.multipleExport = true
          this.exportData = res.data.info_data_export
          this.exportData.forEach(v => {
            v["downloaded"] = false
          })
        } else {
          this.pageSetting.minimizedExport = true
        }
      }
    },

    async flushData() {
      await this.$store.commit("epaymentModule/resetListTopupEpayment")
      await this.$store.commit("epaymentModule/resetInfoTopupEpayment")
      await this.$store.commit("epaymentModule/resetPagination")
      await this.$store.commit("filterGlobalModule/resetFilter")
      await this.$store.commit("epaymentModule/resetSearchTopup")
      await this.$store.commit("epaymentModule/setIsSearchTopup", false)
    }
  },
  // beforeDestroy() {
  // 	this.flushData()
  // }
}
</script>